export default __webpack_public_path__ + "static/media/ico-download-secundary-2.c79adef4.svg";